import { createContext, useContext, useState, useEffect } from 'react';
import api from '../api';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      api.get('/api/auth/me')
        .then(res => setUser(res.data))
        .catch(() => localStorage.removeItem('token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  async function login(email, password) {
    const res = await api.post('/api/auth/login', { email, password });
    if (res.data.mfaRequired) {
      return { mfaRequired: true, mfaToken: res.data.mfaToken };
    }
    localStorage.setItem('token', res.data.token);
    setUser(res.data.user);
    return { user: res.data.user };
  }

  async function loginMfa(mfaToken, code) {
    const res = await api.post('/api/auth/login/mfa', { mfaToken, code });
    localStorage.setItem('token', res.data.token);
    setUser(res.data.user);
    return res.data.user;
  }

  async function refreshUser() {
    const res = await api.get('/api/auth/me');
    setUser(res.data);
    return res.data;
  }

  function logout() {
    localStorage.removeItem('token');
    setUser(null);
  }

  return (
    <AuthContext.Provider value={{ user, loading, login, loginMfa, refreshUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
